import { Link } from "react-router-dom";
import { BiError } from "react-icons/bi";

const PageNotFound = () => {
  return (
    <>
      <div className="page-not-found-main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-not-found-message">
                <div className="error-icon">
                  <BiError />
                </div>
                <h4>oops!</h4>
                <h5>Error 404 - Page not found</h5>
                <p>
                  <small>
                    Let's go <Link to="/">Home</Link> and try from there.
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
